<template>
  <div class="d-flex flex-column">
    <v-select
      :items="documentTypes"
      item-text="text"
      item-value="value"
      label="Document Type"
      v-model="selectedDocumentType"
    ></v-select>
    <v-textarea :rows="10" auto-grow label="Document Content" v-model="documentContent"></v-textarea>
    <v-btn class="mx-auto" @click="submitDocument"> {{ id ? 'Update':'Submit' }}</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    initialData: Object,
  },
  data() {
    return {
      documentTypes: [
        { text: 'Terms and Conditions', value: 'TERMS_AND_CONDITIONS' },
        { text: 'Privacy Policy', value: 'PRIVACY_POLICY' },
        { text: 'Service/Production Description', value: 'SERVICE_DESCRIPTION' },
        { text: 'Other', value: 'OTHER' }
      ],
      selectedDocumentType: null,
      documentContent: "",
      id: null,
    };
  },
  mounted() {
    if (this.initialData) {
      this.id = this.initialData.id;
      this.selectedDocumentType = this.initialData.documentType;
      this.documentContent = this.initialData.documentContent;
    }
  },
  methods: {
    async submitDocument() {
      const payload = {
        id: this.id,
        documentType: this.selectedDocumentType,
        documentContent: this.documentContent,
      };
      // Emit the payload so that the parent can make the API call
      this.$emit("formSubmitted", payload);
      this.$emit("closeDialog");
    },
  },
};
</script>
